import { FC } from 'react'
import { AutoHideMenuBar } from 'room/common/presentation/auto-hide-menu-bar'
import TrainerMenu from 'room/training-room/trainer-menu'

/**
 * The ordinary trainer menu, floating over the stage instead of reserving
 * height below it.
 *
 * The items themselves need no in-person variant: nearly every one is already
 * `hidden={!enabledFeatures.includes(...)}`, and `MicMenuItem` / `CamMenuItem`
 * return null without their features, so a stationary interaction scheme
 * prunes the menu on its own. The one product rule that is not a feature flag
 * - only offer the manual group-work toggle while the script is on a
 * `SIMPLE_GROUPING` activity - lives in `trainer-menu.tsx`, because the item
 * it guards only exists in-person anyway.
 */
export const TrainerMenuInPerson: FC = () => (
	<AutoHideMenuBar>
		<TrainerMenu />
	</AutoHideMenuBar>
)

export default TrainerMenuInPerson
